module.exports = __webpack_public_path__ + "img/yidong.448035c1.gif";